import { Entity } from '@core/entities/entity'
import {
  IPermitTemplateApproval,
  PermitTemplateApprovalRule,
  PermitTemplateApprovalData,
  PermitTemplateApprovalStage,
} from '@core/entities/permit-template-editor'
import { plainToInstance, Type } from 'class-transformer'

export class PermitTemplateApproval extends Entity<IPermitTemplateApproval> {
  @Type(() => PermitTemplateApprovalData)
  data: Array<PermitTemplateApprovalData>

  @Type(() => PermitTemplateApprovalRule)
  rules: Array<PermitTemplateApprovalRule>

  public static new(payload: unknown): PermitTemplateApproval {
    const entity = plainToInstance(PermitTemplateApproval, payload)
    return entity
  }

  public static removeApprovalsByStage(
    approvals: IPermitTemplateApproval,
    stage: PermitTemplateApprovalStage = 'BEFORE_PERMIT_HOLDER',
  ): IPermitTemplateApproval {
    return {
      ...approvals,
      data: approvals.data.filter(
        (approval) => approval.approvalStage !== stage,
      ),
    }
  }

  public getInitialValues(): IPermitTemplateApproval {
    const wrapper = this.toPlain()
    // Transform projects to projectIds in the rules
    if (wrapper.rules) {
      wrapper.rules = wrapper.rules.map((rule) => ({
        ...rule,
        questionSet: {
          type: rule?.questionSet?.type ?? 'PERMIT_HOLDER_QUESTIONS',
          ...(rule?.questionSet?.approval
            ? { approvalId: rule.questionSet.approval.id }
            : {}),
        },
        conditions: rule.conditions?.map((condition) => {
          if (condition.type === 'PROJECT_IS_IN' && condition.projects) {
            return {
              ...condition,
              projectIds: condition.projects.map((p) => p.id),
            }
          }
          return condition
        }),
      }))
    }

    return wrapper
  }
}
